import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InvestmentModel } from '../investment.model';
import { InvestmentService } from '../investment.service';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { ActualSelected } from '../../../shared/utils';
import { BankAccountService } from '../../finanzas/bancos/bankaccount.service';
import { ContactModel } from '../../contact/contact/contact.model';
import { ContactService } from '../../contact/contact/contact.service';
import { PreinvoiceService } from '../../invoice/preinvoice/preinvoice.service';
import { AccountsAndTaxesModel } from '../../invoice/preinvoice/accountsandtaxes.model';
import { AccountingAccountsService } from '../../accounting/accounting-accounts/accounting-accounts.service';
import { AccountingAccountsModel } from '../../accounting/accounting-accounts/accounting-accounts.model';

@Component({
    selector: 'convfact-investment',
    templateUrl: './investment.component.html',
    styleUrls: ['./investment.component.css'],
    standalone: false
})

export class InvestmentComponent implements OnInit {
  investment = new InvestmentModel;
  bankAccounts: BankAccountModel[] = [];
  accounts: AccountingAccountsModel[] = [];
  providers: ContactModel[] = [];
  accountsAndTaxes = new AccountsAndTaxesModel;

  errors = {};
  spinner: boolean = false;
  ready: boolean = false;

  submit(): void { }


  constructor(private preinvoiceService: PreinvoiceService,
    private investmentService: InvestmentService,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
    private router: Router,
    private bankAccountService: BankAccountService,
    private contactService: ContactService,
    private accountingAccounts: AccountingAccountsService
  ) { }

  displayError(error: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(error, '', options);
  }

  saveData = function (investment: InvestmentModel) {
    this.spinner = true;

    if (investment.uid == null) {
      investment.fiscalYear = parseInt(ActualSelected.yearSelected);
      investment.activityUid = ActualSelected.activitySelected;

      this.investmentService.addData(investment)
        .then(investment => {
          this.investment = investment;
          this.spinner = false;
          this.returnToIndex();
        }, error => {
          this.spinner = false;
          this.displayError(error.error['message']);
        }
        )
        .catch(error => {
          this.spinner = false;
          this.displayError("Compruebe los campos obligatorios marcados en rojo");
        })
    } else {
      this.investmentService.editData(investment.uid, investment)
        .then(investment => {
          this.investment = investment;
          this.spinner = false;
          this.returnToIndex();
        })
        .catch(error => {
          this.spinner = false;
          this.displayError("Compruebe los campos obligatorios marcados en rojo")
        })
    }
  }

  ngOnInit() {
    this.bankAccountService.getList().then(bankAccounts => this.bankAccounts = bankAccounts.list);
    this.contactService.getListProviders().then(contacts => this.providers = contacts);

    // TODO-CONTABILIDAD-OLDER
    this.preinvoiceService.accountsAndTaxesData().then(accountsAndTaxes => {
      this.accountsAndTaxes = accountsAndTaxes;

      // this.accountsAndTaxes.taxes = this.accountsAndTaxes.taxes.filter(x => x.type !== 'IRPF');
      this.accountsAndTaxes.taxes = this.accountsAndTaxes.taxes.filter(x => x.type !== 'AIEM');

    });

    const temp = this.router.url.split('/');
    this.spinner = true;

    const typeInvestment = temp[2]; // intangible o material

    // intangible
    if (typeInvestment === 'intangible') {
      this.accountingAccounts.getListInvestmentsAccountsInmobilizado().then(data => this.accounts = data);
    }

    // Material
    if (typeInvestment === 'material') {
      this.accountingAccounts.getListInvestmentsAccountsMaterial().then(data => this.accounts = data);
    }

    if (temp.length == 5) {
      const uid = temp[4];
      this.investmentService.loadData(uid).then(investment => {
        this.investment = investment;
        this.spinner = false;
        this.ready = true;
      })
    }
    else {
      this.spinner = false;
      this.ready = true;
    }
  }

  returnToIndex = function () {
    this.router.navigate(['investment/']);
  }
}
